import React from "react";
import IconButton from "../buttons/IconButton";
import Avatar from "../avatar/Avatar";
import GroupTag from "../tags/GroupTag";
import StatusBadge from "../tags/StatusBadge";

export const ACCOUNT_BODY_COLUMNS = "180px 1fr 200px";

export const USER_BODY_COLUMNS =
  "160px minmax(16px,1fr) 200px minmax(16px,1fr) 120px minmax(16px,1fr) 100px minmax(16px,1fr) 110px minmax(16px,1fr) 40px";

function Txt({ children, style }) {
  return (
    <div
      style={{
        fontFamily: "DM Sans",
        minWidth: 0,
        wordWrap: "break-word",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

function Tag({ children, color, title }) {
  return (
    <div
      title={title}
      style={{
        minHeight: 20,
        padding: "0 12px",
        background: color || "var(--color-brand-600)",
        borderRadius: 100,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        maxWidth: "100%",
      }}
    >
      <Txt
        style={{
          color: "var(--text-cta-primary)",
          fontSize: 13,
          fontWeight: 500,
          lineHeight: "16px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {children}
      </Txt>
    </div>
  );
}

function Cell({ children, align = "left", style }) {
  return (
    <Txt
      style={{
        minWidth: 0,
        textAlign: align,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        ...style,
      }}
    >
      {children}
    </Txt>
  );
}

function AdminRowCard({ columns, gridTemplate, actionIcon, onAction }) {
  return (
    <div
      style={{
        alignSelf: "stretch",
        height: 64,
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <div
        style={{
          flex: "1 1 0",
          height: 64,
          padding: "8px 48px 8px 24px",
          background: "var(--surface-tertiary)",
          overflow: "hidden",
          borderRadius: 24,
          boxSizing: "border-box",
          display: "grid",
          gridTemplateColumns: gridTemplate,
          alignItems: "center",
          minWidth: 0,
        }}
      >
        {columns}
      </div>

      <IconButton
        icon={actionIcon}
        size="md"
        iconSize={14}
        onClick={(e) => {
          e.stopPropagation();
          onAction?.();
        }}
        aria-label="Ver detalle"
        style={{
          width: 48,
          height: 48,
          background: "var(--surface-tertiary)",
          color: "var(--text-primary)",
          borderRadius: 100,
          flexShrink: 0,
        }}
      />
    </div>
  );
}

function SupervisorCell({ photo, name }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <Avatar src={photo} name={name} size={24} />
      <Txt style={{ fontSize: 13, color: "var(--text-primary)", fontWeight: 400, lineHeight: "16px" }}>
        {name}
      </Txt>
    </div>
  );
}

export function AccountCardRow({
  pill = "-",
  name = "-",
  supervisorName = "-",
  supervisorPhoto = null,
  actionIcon,
  onAction,
}) {
  return (
    <AdminRowCard
      gridTemplate={ACCOUNT_BODY_COLUMNS}
      actionIcon={actionIcon}
      onAction={onAction}
      columns={
        <>
          <div style={{ gridColumn: "1", minWidth: 0, paddingRight: 12 }}>
            <Tag title={pill}>{pill}</Tag>
          </div>

          <Cell
            style={{
              gridColumn: "2",
              color: "var(--text-primary)",
              fontSize: 13,
              fontWeight: 400,
              lineHeight: "16px",
            }}
          >
            {name}
          </Cell>

          <div style={{ gridColumn: "3" }}>
            <SupervisorCell photo={supervisorPhoto} name={supervisorName} />
          </div>
        </>
      }
    />
  );
}

export const PERM_GROUP_COLUMNS = "200px 1fr 140px 120px";

export function PermGroupCardRow({ name, description, permissionCount, memberCount, actionIcon, onAction }) {
  return (
    <AdminRowCard
      gridTemplate={PERM_GROUP_COLUMNS}
      actionIcon={actionIcon}
      onAction={onAction}
      columns={
        <>
          <Cell style={{ gridColumn: "1", color: "var(--text-primary)", fontSize: 13, fontWeight: 500, lineHeight: "16px" }}>
            {name}
          </Cell>
          <Cell style={{ gridColumn: "2", color: "var(--text-secondary)", fontSize: 13, fontWeight: 400, lineHeight: "16px" }}>
            {description || "-"}
          </Cell>
          <Cell align="center" style={{ gridColumn: "3", color: "var(--text-secondary)", fontSize: 13, fontWeight: 400, lineHeight: "16px" }}>
            {permissionCount} permisos
          </Cell>
          <Cell align="center" style={{ gridColumn: "4", color: "var(--text-secondary)", fontSize: 13, fontWeight: 400, lineHeight: "16px" }}>
            {memberCount} miembros
          </Cell>
        </>
      }
    />
  );
}



export function UserCardRow({
  username = "-",
  email = "-",
  grupo = "-",
  firstName = "-",
  lastName = "-",
  isActive = true,
  actionIcon,
  onAction,
}) {
  return (
    <AdminRowCard
      gridTemplate={USER_BODY_COLUMNS}
      actionIcon={actionIcon}
      onAction={onAction}
      columns={
        <>
          <Cell
            style={{
              gridColumn: "1",
              color: "var(--text-secondary)",
              fontSize: 13,
              fontWeight: 400,
              lineHeight: "16px",
            }}
          >
            {username}
          </Cell>

          <Cell
            style={{
              gridColumn: "3",
              color: "var(--text-primary)",
              fontSize: 13,
              fontWeight: 400,
              lineHeight: "16px",
            }}
          >
            {email}
          </Cell>

          <div style={{ gridColumn: "5", display: "flex", justifyContent: "center" }}>
            <GroupTag name={grupo} />
          </div>

          <Cell
            align="center"
            style={{
              gridColumn: "7",
              color: "var(--text-primary)",
              fontSize: 13,
              fontWeight: 400,
              lineHeight: "16px",
            }}
          >
            {firstName}
          </Cell>

          <Cell
            align="center"
            style={{
              gridColumn: "9",
              color: "var(--text-primary)",
              fontSize: 13,
              fontWeight: 400,
              lineHeight: "16px",
            }}
          >
            {lastName}
          </Cell>

          <div style={{ gridColumn: "11", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <StatusBadge isActive={isActive} size={22} />
          </div>
        </>
      }
    />
  );
}
